import { render, staticRenderFns } from "./brands.pug?vue&type=template&id=5b0d5b35&lang=pug&"
import script from "./brands.ts?vue&type=script&lang=ts&"
export * from "./brands.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports